<template>
  <el-dialog
    :visible.sync="newVisible"
    :before-close="handleClose"
    title="编辑名称"
    width="500px">
    <FormComp
      v-if="newVisible"
      ref="FileList"
      :form="form" />
    <AppFormSubmit
      :submitting="loading.submit"
      @submit="submit"
      @cancel="cancel"
    />
  </el-dialog>
</template>

<script>
  import FormComp from '../../../../components/FormComponents/index.vue';

  export default {
    name: "EditFlashName",
    components: {
      FormComp,
    },
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      name: String,
    },
    data() {
      return {
        form: [
          {
            attr: 'title', name: '名称', value: this.name, type: 'Input', props: { placeholder: '请输入', rules: { required: true, message: '请输入', target: 'blur' } },
          },
        ],
        newVisible: this.visible,
        loading: {
          submit: false,
        },
      };
    },
    watch: {
      name(vl) {
        this.form[0].value = vl;
      },
      visible(vl) {
        this.newVisible = vl;
      },
      newVisible(vl) {
        this.$emit('update:visible', vl);
      },
    },
    methods: {
      handleClose() {
        this.newVisible = false;
      },
      success(url, id, data) {
        console.log(url, id, data);
        this.handleClose();
        this.$emit('success', url, data, this.isMul);
      },
      submit() {
        const name = this.form[0].value;
        if (this.$refs.FileList.validateForm()) {
          this.$emit("success", { name });
          this.newVisible = false;
          this.clearAll();
        }
      },

      cancel() {
        this.newVisible = false;
        this.$emit("cancel");
        this.clearAll();
      },
      clearAll() {
        this.form[0].value = '';
        this.loading.submit = false;
      },
    },
  };
</script>

<style scoped>

</style>
